// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31b0R","toggleWrap":"styles_toggleWrap__2aPe8","content":"styles_content__1rmpm","selectAreaCode":"styles_selectAreaCode__3ai2T"};